import axiosClient from "../axiosInstance";

const base = "/players";

export const getAllPlayers = async () => {
  const response = await axiosClient.get(`${base}`);
  return response.data;
};

export const getPlayerById = async (playerId) => {
  const response = await axiosClient.get(`${base}/${playerId}`);
  return response.data;
};

export const getPlayerByBSANumber = async (bsaNumber) => {
  const response = await axiosClient.get(`${base}/by-bsa/${bsaNumber}`);
  return response.data;
};

export const createPlayer = async (playerData) => {
  const response = await axiosClient.post(`${base}`, playerData);
  return response.data;
};

export const updatePlayer = async (playerId, playerData) => {
  const response = await axiosClient.patch(`${base}/${playerId}`, playerData);
  return response.data;
};

export const deletePlayer = async (playerId) => {
  const response = await axiosClient.delete(`${base}/${playerId}`);
  return response.data;
};

const playerService = {
  getAllPlayers,
  getPlayerById,
  getPlayerByBSANumber,
  createPlayer,
  updatePlayer,
  deletePlayer,
};

export default playerService;
